import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';

const ScheduleDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('new.scheduleImpact')}
    valueKey="key"
    placeholder={T.translate('filter.scheduleImpact')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, valueKey, searchIcon, ...ScheduleDropDownPropTypes } = DropDownPropTypes;

ScheduleDropDown.propTypes = ScheduleDropDownPropTypes;
export default ScheduleDropDown;
